package com.nonopn.skywatcher.common.app.pages.scan

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.app.qrcode.ScanQrCode
import com.nonopn.skywatcher.common.app.home.LocalThunderDetectionModel
import com.nonopn.skywatcher.common.app.navigation.RouterAdministrators
import com.nonopn.skywatcher.common.app.navigation.RouterUsers
import com.nonopn.skywatcher.common.app.pages.administrators.UserMode
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.page_administrators_add_new_administrator_couldnt_invite_text
import com.nonopn.skywatcher.common.app.res.page_administrators_add_new_administrator_couldnt_invite_title
import com.nonopn.skywatcher.common.app.res.page_users_add_new_user_couldnt_invite_text
import com.nonopn.skywatcher.common.app.res.page_users_add_new_user_couldnt_invite_title
import com.nonopn.skywatcher.design.local.LocalConfirmPopup
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import eu.codlab.viewmodel.rememberViewModel

@Composable
fun ScanQrContent(
    modifier: Modifier,
    thunderDetection: ThunderDetectionWithMetadata,
    userOrAdminMode: UserMode
) {
    val localThunderDetectionModel = LocalThunderDetectionModel.current
    val localThunderDetectionState by localThunderDetectionModel.states.collectAsState()

    val model = rememberViewModel {
        ScanQrContentModel(
            thunderDetection,
            currentApi = localThunderDetectionState.currentApi!!,
            userOrAdminMode = userOrAdminMode
        )
    }
    val state by model.states.collectAsState()
    val popup = LocalConfirmPopup.current

    val titleError = when (userOrAdminMode) {
        UserMode.User ->
            Res.string.page_users_add_new_user_couldnt_invite_title.localized()

        UserMode.Admin ->
            Res.string.page_administrators_add_new_administrator_couldnt_invite_title.localized()
    }

    val textError = when (userOrAdminMode) {
        UserMode.User -> Res.string.page_users_add_new_user_couldnt_invite_text.localized()

        UserMode.Admin -> Res.string.page_administrators_add_new_administrator_couldnt_invite_text.localized()
    }

    Box(modifier) {
        ScanQrCode(
            Modifier.fillMaxSize(),
        ) {
            model.inviteToSentinel(
                it,
                onSuccess = {
                    val route = when (userOrAdminMode) {
                        UserMode.User -> RouterUsers
                        UserMode.Admin -> RouterAdministrators
                    }
                    localThunderDetectionModel.show(
                        route.navigateTo(localThunderDetectionState.selectedThunderDetection.detection.uuid)
                    )
                },
                onError = {
                    popup.show(
                        titleError,
                        textError,
                        onDismiss = {
                            model.commitAlert()
                        },
                        onConfirm = {
                            model.commitAlert()
                        }
                    )
                }
            )

            false
        }

        if (state.isInviting) {
            Column(
                Modifier.fillMaxSize().background(AppColor.BackgroundDarkBlueSemiTransparent),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                CircularProgressIndicator()
            }
        }
    }
}